import { useDispatch, useSelector } from 'react-redux'
import { FaAngleDoubleRight, FaAngleDoubleLeft } from 'react-icons/fa'
import * as ACT from './actions'
import s from './Sidebar.scss'
import cn from 'classnames'

const Sidebar = ({ className, buttons, title, sections, sidebarType }) => {
  const reduxDispatch = useDispatch()

  const sidebar = useSelector(state => state.sidebar)
  const isSidebarOpen = sidebar[sidebarType] ? sidebar[sidebarType].isOpen : true

  const toggleSidebar = () => {
    reduxDispatch({
      type: ACT.TOGGLE_SIDEBAR,
      payload: {
        sidebarType,
        isOpen: !isSidebarOpen
      }
    })
  }

  return (
    <div className={cn(s.container, className)}>
      {buttons && <div className={s.header}>{buttons.map(button => button)}</div>}
      <div className={s.content}>
        {sidebarType && (
          <div
            className={cn(s.sidebarToggler, { [s.collapsedToggler]: !isSidebarOpen })}
            onClick={toggleSidebar}
          >
            {isSidebarOpen ? (
              <>
                <FaAngleDoubleRight />
                <span>Collapse Sidebar</span>
              </>
            ) : (
              <FaAngleDoubleLeft />
            )}
          </div>
        )}
        <div className={cn({ [s.visible]: isSidebarOpen }, s.toggledContent)}>
          {title && <div className={s.title}>{title}</div>}
          {sections.map((section, index) => {
            if (section.condition === undefined || section.condition) {
              return (
                <div
                  key={index}
                  className={cn(s.section, {
                    [section.sectionClassName]: section.sectionClassName
                  })}
                >
                  {section.title && <div className={s.sectionTitle}>{section.title}</div>}
                  {section.content}
                </div>
              )
            } else {
              return null
            }
          })}
        </div>
      </div>
    </div>
  )
}

export default Sidebar
